import { Injectable } from '@angular/core';
import { MonthOption, YearOption } from "../interfaces/form-model";

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  private readonly months: MonthOption[];
  private readonly next10Years: YearOption[];

  constructor() {
    this.months = this.createMonthOptions();
    this.next10Years = this.createNext10YearsOptions();
  }

  getMonths(): MonthOption[] {
    return this.months;
  }

  getDefaultMonth(): string {
    return this.months[0].value.toString();
  }

  getNext10Years(): YearOption[] {
    return this.next10Years;
  }

  getCurrentYear(): string {
    return this.next10Years[0].value.toString();
  }

  private createMonthOptions(): MonthOption[] {
    return [
      {
        value: 1,
        label: "01 - January",
      },
      {
        value: 2,
        label: "02 - February",
      },
      {
        value: 3,
        label: "03 - March",
      },
      {
        value: 4,
        label: "04 - April",
      },
      {
        value: 5,
        label: "05 - May",
      },
      {
        value: 6,
        label: "06 - June",
      },
      {
        value: 7,
        label: "07 - July",
      },
      {
        value: 8,
        label: "08 - August",
      },
      {
        value: 9,
        label: "09 - September",
      },
      {
        value: 10,
        label: "10 - October",
      },
      {
        value: 11,
        label: "11 - November",
      },
      {
        value: 12,
        label: "12 - December",
      },
    ];
  }

  private createNext10Years(): number[] {
    const current = new Date().getFullYear();
    return Array.from(Array(11).keys()).map(value => current + value);
  }

  private createNext10YearsOptions(): YearOption[] {
    return this.createNext10Years().map(value => ({ value: value, label: value.toString() }) );
  }
}
